import { render, staticRenderFns } from "./acl-select.vue?vue&type=template&id=505c73c2&scoped=true&"
import script from "./acl-select.ts?vue&type=script&lang=ts&"
export * from "./acl-select.ts?vue&type=script&lang=ts&"
import style0 from "./acl-select.scss?vue&type=style&index=0&id=505c73c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505c73c2",
  null
  
)

export default component.exports